import React, { PureComponent } from 'react';
import upperFirst from 'lodash/upperFirst';
import PropTypes from 'prop-types';
import BucketHeader from './BucketHeader';
import SeeMoreButton from './SeeMoreButton';
import MediaCardContent from 'eventbrite_design_system/mediaCardContent/MediaCardContent';
import Card from 'eventbrite_design_system/card/Card';
import {
    GRID_TYPE,
    STANDARD_STYLE,
} from 'eventbrite_design_system/mediaCardContent/constants';
import TrendingSvg from 'eventbrite_design_system/iconography/icons/Trending';
import {
    GA_CITY_BROWSE_CATEGORY,
    GA_VIEW_TRENDING_SEARCH_ACTION,
    GA_VIEW_ALL_TRENDING_SEARCHES_ACTION,
} from '../constants';
import { setWindowLocation } from 'js-utils/http';
import { getTrendingSearchesPathForLocation } from '../utils/trending';

const httpRefererWasSearchEngine = (httpReferer) =>
    httpReferer.search('google|bing|yahoo') >= 0;

const _formattedTitle = (id, searchTerm) => (
    <span className="eds-text-bl eds-text-weight--regular eds-text-bm eds-text-color--ui-blue">
        {id + 1}. {upperFirst(searchTerm)}
    </span>
);

const _getTrendingSearchCards = (content, trackClick) => {
    const classes =
        'eds-l-pad-hor-3 eds-l-pad-vert-2 eds-g-cell eds-g-cell-md-3-12 eds-g-cell-12-12';

    return content.map(({ id, searchTerm, searchPath }) => (
        <div key={id} className={classes}>
            <Card style="simple">
                <MediaCardContent
                    style={STANDARD_STYLE}
                    type={GRID_TYPE}
                    linkUrl={searchPath}
                    title={_formattedTitle(id, searchTerm)}
                    // eslint-disable-next-line babel/no-invalid-this
                    onClick={trackClick.bind(this, searchTerm)}
                    shouldHideImage={true}
                />
            </Card>
        </div>
    ));
};

const _handleSeeMoreClick = (
    httpReferer,
    currentPlace,
    trackGAEventOnPageUnload,
    action,
    url,
) => {
    if (httpRefererWasSearchEngine(httpReferer)) {
        trackGAEventOnPageUnload({
            category: GA_CITY_BROWSE_CATEGORY,
            action,
            label: currentPlace,
        });
    }

    /* Need to fire tracking action on the seemore, so necessary to
    manually set windowlocation rather that relying on the link. */
    if (url) {
        setWindowLocation(url);
    }
};

const _handleSelectSearchClick = (httpReferer, searchTerm, trackGAEvent) => {
    if (httpRefererWasSearchEngine(httpReferer)) {
        trackGAEvent({
            category: GA_CITY_BROWSE_CATEGORY,
            action: GA_VIEW_TRENDING_SEARCH_ACTION,
            label: searchTerm,
            requestPath: window.location.pathname,
        });
    }
};

export default class TrendingSearchesBucket extends PureComponent {
    static propTypes = {
        content: PropTypes.arrayOf(
            PropTypes.shape({
                searchTerm: PropTypes.string.isRequired,
                formattedSearch: PropTypes.string.isRequired,
            }),
        ),
        name: PropTypes.string,
        httpReferer: PropTypes.string,
        trackGAEvent: PropTypes.func,
        trackGAEventOnPageUnload: PropTypes.func,
        currentPlace: PropTypes.string,
    };

    render() {
        const {
            currentPlace,
            content,
            name,
            httpReferer,
            locationSlug,
            trackGAEvent,
            trackGAEventOnPageUnload,
        } = this.props;
        const trendingSearchesPath = getTrendingSearchesPathForLocation(
            locationSlug,
        );

        return (
            <div>
                <BucketHeader
                    title={name}
                    iconType={<TrendingSvg />}
                    linkUrl={trendingSearchesPath}
                    template="trending_searches"
                    trackSeeMore={_handleSeeMoreClick.bind(
                        null,
                        httpReferer,
                        currentPlace,
                    )}
                    trackGAEvent={trackGAEvent}
                    gaAction={GA_VIEW_ALL_TRENDING_SEARCHES_ACTION}
                />
                <div className="eds-g-group">
                    {_getTrendingSearchCards(
                        content,
                        _handleSelectSearchClick.bind(
                            null,
                            httpReferer,
                            trackGAEvent,
                        ),
                    )}
                </div>
                <div className="eds-l-pad-top-6">
                    <div className="eds-show-down-sn eds-align--center">
                        <div className="eds-g-cell">
                            <SeeMoreButton
                                linkUrl={trendingSearchesPath}
                                title={name}
                                trackClick={_handleSeeMoreClick.bind(
                                    null,
                                    httpReferer,
                                    currentPlace,
                                    trackGAEventOnPageUnload,
                                )}
                                gaAction={GA_VIEW_ALL_TRENDING_SEARCHES_ACTION}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
